import styled from 'styled-components/macro';

const Name = styled.div`
  padding-bottom: 5px;
  font-size: 16px;
  line-height: 1.3;
  color: #fff;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default Name;
